import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { FileText, Package, Clock, CheckCircle, Download, Eye, Filter, Search, Calendar, TrendingUp } from 'lucide-react';
export function FactoryPurchaseOrders() {
  const purchaseOrders = [{
    id: 'PO-FAC-001',
    poNumber: 'PO-2023-001',
    agregator: 'PTX',
    orderDate: '10 Okt 2023',
    dueDate: '13 Okt 2023',
    status: 'production',
    statusLabel: 'Dalam Produksi',
    products: [{
      name: 'Indomie Goreng Special',
      sku: 'SKU-IM-001',
      quantity: 500,
      unit: 'Karton',
      price: 31000
    }, {
      name: 'Indomie Soto',
      sku: 'SKU-IM-002',
      quantity: 300,
      unit: 'Karton',
      price: 31000
    }],
    totalValue: 24800000,
    progress: 65,
    estimatedCompletion: '13 Okt 2023'
  }, {
    id: 'PO-FAC-002',
    poNumber: 'PO-2023-005',
    agregator: 'PTX',
    orderDate: '8 Okt 2023',
    dueDate: '11 Okt 2023',
    status: 'ready',
    statusLabel: 'Siap Kirim',
    products: [{
      name: 'Indomie Ayam Bawang',
      sku: 'SKU-IM-003',
      quantity: 400,
      unit: 'Karton',
      price: 31000
    }],
    totalValue: 12400000,
    progress: 100,
    estimatedCompletion: 'Selesai'
  }, {
    id: 'PO-FAC-003',
    poNumber: 'PO-2023-008',
    agregator: 'PTX',
    orderDate: '11 Okt 2023',
    dueDate: '14 Okt 2023',
    status: 'pending',
    statusLabel: 'Menunggu Produksi',
    products: [{
      name: 'Indomie Goreng Special',
      sku: 'SKU-IM-001',
      quantity: 600,
      unit: 'Karton',
      price: 31000
    }],
    totalValue: 18600000,
    progress: 0,
    estimatedCompletion: '14 Okt 2023'
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'production':
        return 'warning';
      case 'ready':
        return 'success';
      case 'pending':
        return 'neutral';
      default:
        return 'neutral';
    }
  };
  return <div className="space-y-6" data-id="element-2063">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2064">
        <div data-id="element-2065">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-2066">Purchase Orders</h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2067">
            Kelola PO dari agregator
          </p>
        </div>
        <div className="flex gap-2" data-id="element-2068">
          <Button variant="outline" size="sm" icon={<Filter className="w-4 h-4" data-id="element-2070" />} data-id="element-2069">
            Filter
          </Button>
          <Button variant="primary" size="sm" icon={<Download className="w-4 h-4" data-id="element-2072" />} data-id="element-2071">
            Export
          </Button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-2073">
        <Card className="p-4 bg-blue-50 border-blue-200" data-id="element-2074">
          <div className="flex items-center justify-between" data-id="element-2075">
            <div data-id="element-2076">
              <p className="text-xs text-blue-700 mb-1" data-id="element-2077">Total PO</p>
              <p className="text-2xl font-bold text-blue-900" data-id="element-2078">8</p>
            </div>
            <FileText className="w-8 h-8 text-blue-600" data-id="element-2079" />
          </div>
        </Card>

        <Card className="p-4 bg-amber-50 border-amber-200" data-id="element-2080">
          <div className="flex items-center justify-between" data-id="element-2081">
            <div data-id="element-2082">
              <p className="text-xs text-amber-700 mb-1" data-id="element-2083">In Production</p>
              <p className="text-2xl font-bold text-amber-900" data-id="element-2084">3</p>
            </div>
            <Clock className="w-8 h-8 text-amber-600" data-id="element-2085" />
          </div>
        </Card>

        <Card className="p-4 bg-green-50 border-green-200" data-id="element-2086">
          <div className="flex items-center justify-between" data-id="element-2087">
            <div data-id="element-2088">
              <p className="text-xs text-green-700 mb-1" data-id="element-2089">Ready to Ship</p>
              <p className="text-2xl font-bold text-green-900" data-id="element-2090">2</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" data-id="element-2091" />
          </div>
        </Card>

        <Card className="p-4 bg-violet-50 border-violet-200" data-id="element-2092">
          <div className="flex items-center justify-between" data-id="element-2093">
            <div data-id="element-2094">
              <p className="text-xs text-violet-700 mb-1" data-id="element-2095">Total Value</p>
              <p className="text-2xl font-bold text-violet-900" data-id="element-2096">Rp 56Jt</p>
            </div>
            <TrendingUp className="w-8 h-8 text-violet-600" data-id="element-2097" />
          </div>
        </Card>
      </div>

      {/* PO List */}
      <div className="space-y-4" data-id="element-2098">
        {purchaseOrders.map(po => <Card key={po.id} className="p-6" data-id="element-2099">
            <div className="flex items-start justify-between mb-4" data-id="element-2100">
              <div data-id="element-2101">
                <div className="flex items-center gap-3 mb-2" data-id="element-2102">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-2103">
                    {po.poNumber}
                  </h3>
                  <Badge variant={getStatusColor(po.status)} data-id="element-2104">
                    {po.statusLabel}
                  </Badge>
                </div>
                <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-2105">
                  <span data-id="element-2106">ID: {po.id}</span>
                  <span className="text-slate-400" data-id="element-2107">•</span>
                  <span data-id="element-2108">From: {po.agregator}</span>
                  <span className="text-slate-400" data-id="element-2109">•</span>
                  <div className="flex items-center gap-1" data-id="element-2110">
                    <Calendar className="w-4 h-4" data-id="element-2111" />
                    <span data-id="element-2112">Order: {po.orderDate}</span>
                  </div>
                  <span className="text-slate-400" data-id="element-2113">•</span>
                  <div className="flex items-center gap-1" data-id="element-2114">
                    <Clock className="w-4 h-4" data-id="element-2115" />
                    <span data-id="element-2116">Due: {po.dueDate}</span>
                  </div>
                </div>
              </div>
              <div className="text-right" data-id="element-2117">
                <p className="text-sm text-slate-600 mb-1" data-id="element-2118">Total Value</p>
                <p className="text-2xl font-bold text-blue-600" data-id="element-2119">
                  Rp {(po.totalValue / 1000000).toFixed(1)}Jt
                </p>
              </div>
            </div>

            {/* Products */}
            <div className="mb-4 p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2120">
              <p className="text-xs font-bold text-slate-700 mb-3" data-id="element-2121">Products:</p>
              <div className="space-y-2" data-id="element-2122">
                {po.products.map((product, i) => <div key={i} className="flex items-center justify-between p-3 bg-white rounded-lg" data-id="element-2123">
                    <div className="flex-1" data-id="element-2124">
                      <p className="font-medium text-slate-900" data-id="element-2125">
                        {product.name}
                      </p>
                      <p className="text-xs text-slate-600" data-id="element-2126">
                        SKU: {product.sku}
                      </p>
                    </div>
                    <div className="text-right" data-id="element-2127">
                      <p className="font-bold text-slate-900" data-id="element-2128">
                        {product.quantity} {product.unit}
                      </p>
                      <p className="text-xs text-slate-600" data-id="element-2129">
                        @ Rp {product.price.toLocaleString()}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Progress */}
            {po.status === 'production' && <div className="mb-4" data-id="element-2130">
                <div className="flex justify-between items-center mb-2" data-id="element-2131">
                  <span className="text-sm font-medium text-slate-700" data-id="element-2132">
                    Production Progress
                  </span>
                  <span className="text-sm font-bold text-slate-900" data-id="element-2133">
                    {po.progress}%
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-2134">
                  <div className="h-full bg-gradient-to-r from-orange-500 to-orange-600 rounded-full" style={{
              width: `${po.progress}%`
            }} data-id="element-2135"></div>
                </div>
                <p className="text-xs text-slate-600 mt-1" data-id="element-2136">
                  Est. completion: {po.estimatedCompletion}
                </p>
              </div>}

            {/* Actions */}
            <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-2137">
              <Button variant="outline" size="sm" icon={<Eye className="w-4 h-4" data-id="element-2139" />} data-id="element-2138">
                View Details
              </Button>
              <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-2141" />} data-id="element-2140">
                Download PDF
              </Button>
              {po.status === 'ready' && <Button variant="primary" size="sm" icon={<CheckCircle className="w-4 h-4" data-id="element-2143" />} data-id="element-2142">
                  Confirm Shipment
                </Button>}
              {po.status === 'pending' && <Button variant="primary" size="sm" data-id="element-2144">
                  Start Production
                </Button>}
            </div>
          </Card>)}
      </div>
    </div>;
}